<template>
  <div class="position-relative" v-click-outside="hide">
    <button
      class="btn btn-link text-white btn-sm mr-2"
      :id="id"
      type="button"
      @click="show = !show"
    >
      {{ title || $t('word.select') }}
      <span
        class="badge badge-pill badge-light mr-2"
        v-if="value && value.length > 0"
      >
        {{ value.length }}
      </span>

      <i class="fa fa-chevron-down"/>
    </button>
    <div
      class="mt-2 p-3 selector position-absolute bg-secondary text-white"
      style="min-width: 200px"
      v-if="show"
    >
      <label
        v-for="option in options"
        :key="option.key"
        class="selector-item d-flex justify-content-start clickable"
        :class="{'text-bold': value.includes(option.key)}"
      >
        <input
          type="checkbox"
          class="mr-2"
          :id="`filter-region-${option.key}`"
          :value="option.key"
          v-model="inputVal"
        /> {{ option.value }}
      </label>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'MultiSelect',
  props: {
    title: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    hide() {
      this.show = false;
    },
  },
  directives: {
    'click-outside': ClickOutside,
  },
};
</script>

<style scoped>
.selector-item:hover {
  font-weight: bold;
}
</style>
